// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { extendTheme } from "@chakra-ui/react";
import { createBreakpoints, mode } from "@chakra-ui/theme-tools";
import { Theme } from "@chakra-ui/theme";

export const theme: Theme = extendTheme({
  breakpoints: createBreakpoints({
    sm: "37.5em", // 600px
    md: "60em", // 960px
    lg: "90em", // 1440px
    xl: "120em", // 1920px
  }),
  fonts: {
    heading: "TofinoPersonal",
    body: "TofinoPersonal",
  },
  space: {
    xxsmall: "4px",
    xsmall: "8px",
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "40px",
    xxlarge: "64px",
  },
  sizes: {
    "page.content": "1600px",
  },
  colors: {
    text: "#000",
    background: "#F7FAFC",
    primary: "#2D54E8",
    black: "#000000",
    dark_gray: "#777777",
    medium_gray: "#A1A1A1",
    light_gray: "#C9C9C9",
    pale_gray: "#E4E5E6",
    pale_blue: "#F5F5F7",
    white: "#FFF",
    pink: "#F853AA",
    success: "#03D596",
    error: "#B5342A",
    severe: "#B5342A",
    warning: "#E07800",
    blue: {
      50: "#e5ecff",
      100: "#b8c7fc",
      200: "#8ba1f5",
      300: "#5d7cee",
      400: "#3057e8",
      500: "#173dcf",
      600: "#0f2fa2",
      700: "#082275",
      800: "#031449",
      900: "#00071e",
    },
    red: {
      50: "#ffe7e6",
      100: "#f6c2bf",
      200: "#e99c97",
      300: "#de756d",
      400: "#d44f45",
      500: "#ba362b",
      600: "#922921",
      700: "#681c17",
      800: "#410f0b",
      900: "#1d0200",
    },
    green: {
      50: "#dafff6",
      100: "#adffe7",
      200: "#7cfed8",
      300: "#4bfdc8",
      400: "#1dfcb9",
      500: "#03e29f",
      600: "#00b07c",
      700: "#007e58",
      800: "#004c34",
      900: "#001b10",
    },
    orange: {
      50: "#fff2da",
      100: "#ffdaae",
      200: "#ffc47d",
      300: "#ffac4c",
      400: "#ff941a",
      500: "#e67b00",
      600: "#b36000",
      700: "#814300",
      800: "#4f2800",
      900: "#1f0c00",
    },
  },
  styles: {
    a: {
      textDecoration: "none",
      _hover: {
        textDecoration: "none",
      },
    },
  },
  fontSizes: {
    xsm: "12px",
    sm: "14px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    "2xl": "42px",
  },
  components: {
    Avatar: {
      sizes: {
        sm: {
          width: "24px",
          height: "24px",
        },
        md: {
          width: "40px",
          height: "40px",
        },
        lg: {
          width: "96px",
          height: "96px",
        },
        xl: {
          width: "136px",
          height: "136px",
        },
      },
      defaultProps: {
        bg: "pale_gray",
      },
    },
    Radio: {
      parts: ["control"],
      baseStyle: {
        control: {
          borderColor: "medium_gray",
          _checked: {
            bg: "primary",
            borderColor: "primary",
            _hover: {
              bg: "primary",
            },
          },
        },
      },
      defaultProps: {},
    },
    IconButton: {
      baseStyle: {
        bg: "primary",
      },
      variants: {
        ghost: {
          bg: "transparent",
          _hover: {
            bg: "transparent",
            boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.1)",
          },
          _active: {
            bg: "transparent",
            boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.3)",
          },
        },
      },
    },
    Button: {
      baseStyle: {
        fontWeight: "normal",
        m: "xxsmall",
        borderRadius: "32px",
      },
      sizes: {
        md: {
          pl: "small",
          pr: "small",
          py: "xsmall",
        },
        lg: {
          pl: "medium",
          pr: "medium",
          py: "small",
          fontSize: "md",
          minWidth: "144px",
        },
        xl: {
          py: "small",
          minWidth: "172px",
          paddingInline: "medium",
          fontSize: "md",
        },
      },
      variants: {
        solid: {
          color: "white",
          bg: "primary",
          _hover: {
            bg: "auto",
            boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.1)",
            _disabled: {
              bg: "auto",
            },
          },
          _active: {
            bg: "auto",
            boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.3)",
          },
        },
        severe: {
          color: "white",
          bg: "error",
          _hover: {
            bg: "auto",
            boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.1)",
            _disabled: {
              bg: "auto",
            },
          },
          _active: {
            bg: "auto",
            boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.3)",
          },
        },
        ghost: {
          color: "black",
          bg: "transparent",
          _hover: {
            bg: "transparent",
            boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.1)",
            _disabled: {
              bg: "auto",
            },
          },
          _active: {
            bg: "transparent",
            boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.3)",
          },
        },
        link: {
          color: "primary",
          textDecoration: "underline",
          bg: "transparent",
          _hover: {
            bg: "transparent",
            boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.1)",
            _disabled: {
              bg: "auto",
            },
          },
          _active: {
            bg: "transparent",
            boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.3)",
          },
        },
        outline: {
          color: "black",
          bg: "transparent",
          _hover: {
            bg: "auto",
            boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.1)",
            _disabled: {
              bg: "auto",
            },
          },
          _active: {
            bg: "auto",
            boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.3)",
          },
        },
      },
      defaultProps: {},
    },
    Input: {
      parts: ["field", "addon"],
      baseStyle: {
        field: {
          _placeholder: {
            color: "medium_gray",
          },
        },
      },
      sizes: {
        sm: {
          field: {
            borderRadius: "4px",
          },
        },
        md: {
          field: {
            h: "48px",
          },
          addon: {
            h: "48px",
          },
        },
        lg: {
          field: {
            h: "56px",
          },
          addon: {
            h: "56px",
          },
        },
      },
      variants: {
        outline: {
          field: {
            borderColor: "light_gray",
          },
        },
        ghost: {
          field: {
            border: "none",
          },
        },
      },
      defaultProps: {
        focusBorderColor: "primary",
        errorBorderColor: "error",
      },
    },
    Checkbox: {
      parts: ["control"],
      baseStyle: {
        control: {
          borderColor: "medium_gray",
          _checked: {
            bg: "primary",
            borderColor: "primary",
            _hover: {
              bg: "primary",
            },
          },
        },
      },
      defaultProps: {},
    },
    LayoutGrid: {
      baseStyle: {
        flex: 1,
        display: "grid",
        gridColumnGap: {
          base: "medium",
          lg: "large",
        },
        gridTemplateColumns: {
          base: "repeat(4, minmax(auto, 1fr))",
          sm: "repeat(8, minmax(auto, 1fr))",
          md: "repeat(12, minmax(auto, 1fr))",
        },
      },
    },
    Container: {
      variants: {
        page: {
          paddingInlineStart: "0px",
          paddingInlineEnd: "0px",
          maxWidth: "page.content",
          display: "flex",
          _after: {
            content: "''",
            mr: ["small", "medium", "large", "large", "large"],
          },
          _before: {
            content: "''",
            ml: ["small", "medium", "large", "large", "large"],
          },
        },
      },
      defaultProps: {
        variant: "page",
      },
    },
    AppBar: {
      baseStyle: {
        display: "flex",
        height: {
          base: "64px",
          sm: "80px",
          xl: "104px",
        },
      },
    },
    BlueprintIcon: {
      sizes: {
        sm: {
          width: "16px",
          height: "16px",
        },
        md: {
          width: "24px",
          height: "24px",
        },
        lg: {
          width: "48px",
          height: "48px",
        },
      },
      defaultProps: {
        size: "md",
        fill: "black",
      },
    },
    Menu: {
      parts: ["list", "item"],
      baseStyle: {
        list: {
          boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.32)",
        },
        item: {
          minHeight: "46px",
        },
      },
      sizes: {
        sm: {
          item: {
            paddingTop: "xxsmall",
            paddingBottom: "xxsmall",
            minHeight: "30px",
            fontSize: "sm",
          },
        },
      },
    },
    Divider: {
      baseStyle: {
        borderColor: "light_gray",
      },
    },
    Heading: {
      sizes: {
        sm: {
          fontSize: "md",
        },
        md: {
          fontSize: "md",
        },
        lg: {
          fontSize: "lg",
        },
        xl: {
          fontSize: "xl",
        },
        "2xl": {
          fontSize: "2xl",
        },
      },
    },
    Text: {
      baseStyle: {
        fontSize: "md",
      },
    },
    Tabs: {
      parts: ["tab", "tablist"],
      variants: {
        line: variantLine,
      },
    },
    Select: {
      parts: ["root"],
      baseStyle: {
        root: {
          cursor: "pointer",
          m: "0px",
          borderRadius: "5px",
          borderColor: "light_gray",
          _readOnly: {},
        },
      },
      sizes: {
        // extra medium
        xmd: {
          root: {
            height: "40px",
            pl: "15px",
          },
        },
        md: {
          root: {
            height: "48px",
          },
        },
        lg: {
          root: {
            height: "56px",
          },
        },
      },
      defaultProps: {
        size: "md",
      },
    },
    Form: {
      parts: ["requiredIndicator"],
      baseStyle: {
        requiredIndicator: {
          color: "inherit",
        },
      },
    },
    FormError: {
      parts: ["text", "icon"],
      baseStyle: {
        text: {
          color: "error",
        },
        icon: {
          color: "error",
        },
      },
    },
    BlueprintRadio: {
      baseStyle: {
        mr: "xsmall",
        fill: "pale_gray",
        _checked: {
          fill: "primary",
        },
      },
    },
  },
});

function variantLine(props: any): any {
  const { orientation } = props;
  const isVertical = orientation === "vertical";
  const borderProp =
    orientation === "vertical" ? "borderStart" : "borderBottom";
  const marginProp = isVertical ? "marginStart" : "marginBottom";

  return {
    tablist: {
      [borderProp]: "3px solid",
      borderColor: "pale_gray",
    },
    tab: {
      [borderProp]: "3px solid",
      borderColor: "transparent",
      [marginProp]: "-3px",
      _selected: {
        color: "black",
        fontWeight: "bold",
        borderColor: "primary",
      },
      _active: {
        bg: mode("gray.200", "whiteAlpha.300")(props),
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
      },
    },
  };
}
